(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-image"] && !Shopify.designMode) return;
  try {
    const resourceImageGalleries = new WeakMap();

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-image-direction]');

    if (!arrow) return;

    const resourceImage = arrow.closest('.resource-image');
    const galleryData = resourceImage?.querySelector('[data-resource-image-gallery]');

    if (!resourceImage || !galleryData) return;

    event.preventDefault();
    event.stopPropagation();

    if (resourceImage.dataset.galleryLoading === 'true') return;

    let gallery = resourceImageGalleries.get(resourceImage);

    if (!gallery) {
      try {
        gallery = JSON.parse(galleryData.textContent).filter(
          (item, index, items) =>
            item?.src && items.findIndex((candidate) => candidate.src === item.src) === index
        );
        resourceImageGalleries.set(resourceImage, gallery);
      } catch {
        return;
      }
    }

    if (gallery.length < 2) return;

    const currentIndex = Number(resourceImage.dataset.galleryIndex || 0);
    const step = arrow.dataset.imageDirection === 'next' ? 1 : -1;
    const targetIndex = (currentIndex + step + gallery.length) % gallery.length;
    const activeLayer = resourceImage.dataset.activeLayer || 'primary';
    const targetLayer = activeLayer === 'primary' ? 'secondary' : 'primary';
    const targetImage = resourceImage.querySelector(`.resource-image__image--${targetLayer}`);
    const targetItem = gallery[targetIndex];

    if (!targetImage || !targetItem?.src) return;

    const showTargetImage = () => {
      targetImage.removeAttribute('srcset');
      targetImage.removeAttribute('sizes');
      targetImage.src = targetItem.src;
      targetImage.alt = targetItem.alt || '';
      resourceImage.dataset.galleryIndex = String(targetIndex);
      resourceImage.dataset.activeLayer = targetLayer;
      resourceImage.dataset.galleryInteracted = 'true';
      resourceImage.dataset.galleryLoading = 'false';
    };

    resourceImage.dataset.galleryLoading = 'true';

    const preloadImage = new Image();
    preloadImage.addEventListener('load', showTargetImage, { once: true });
    preloadImage.addEventListener(
      'error',
      () => {
        resourceImage.dataset.galleryLoading = 'false';
      },
      { once: true }
    );
    preloadImage.src = targetItem.src;
  });
  } catch(e) { console.error(e); }
})();

})();
